"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NoFrameImage = require("./NoFrameImage");
Object.keys(_NoFrameImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NoFrameImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NoFrameImage[key];
    }
  });
});
var _BottomFrameImage = require("./BottomFrameImage");
Object.keys(_BottomFrameImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BottomFrameImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BottomFrameImage[key];
    }
  });
});
var _TopFrameImage = require("./TopFrameImage");
Object.keys(_TopFrameImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopFrameImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopFrameImage[key];
    }
  });
});
var _TextPosition = require("./TextPosition");
Object.keys(_TextPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextPosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TextPosition[key];
    }
  });
});
